import React from 'react';

// Import components
import { DrawerWrapper } from './styles';
import { Favourites } from 'components/layout/nav/nav_toolbar/favourites/Favourites';
import { Reminders } from 'components/layout/nav/nav_toolbar/reminders/Reminders';

function Drawers() {
	return (
		<DrawerWrapper>
			<Favourites />
			<Reminders />
		</DrawerWrapper>
	);
}

export default Drawers;
